<template>
  <div class="container">

    <div class="row px-0 mx-1 contenedor">

      <div id="image-card" class="col-lg-6">
        <div class="align-items-center">
          <!-- <img  class="banner-image" :src="'https://mybarber.howertpi.com/assets/'+logo" alt="Logo empresa"> -->
          <img class="banner-image" src="../../../public/logo_midelfin.png" alt="Logo empresa">
        </div>
      </div>

      <div id="login-card" class="col-lg-6 text-center">
        <CRow class="mt-3">
          <CCol xxl="12" xl="12" md="12" sm="12" class="text-center">
            <h4>¿EN QUÉ SEDE DESEA TRABAJAR?</h4>
          </CCol>
          <CCol xxl="6" xl="6" md="12" sm="12" v-for="(item, index) in campus" :key="index" class="text-center">
            <CCard class="mr-1 card hs-primary" @click="mtdSetCampu(item)" body-wrapper text-color="white">
              <strong>{{ item.name }}</strong>
            </CCard>
          </CCol>
        </CRow>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "c-home-campus",
  props: {
    campus: {
      type: Array,
      default: [],
    },
    logo: String,
  },
  methods: {
    mtdSetCampu: function (payload) {
      this.$emit("mtdSetCampu", payload);
    },
  },
};
</script>

<style scoped>
.hs-primary {
  background-color: #42B883;
  color: #0F172A !important;
}

.hs-primary:hover {
  background-color: #136949;
  color: #DEECFB !important;
}

.card {
  cursor: pointer;
}

.contenedor {
  display: flex;
  align-items: center;
  height: 70vh;
  /* Ajusta según sea necesario */
}

.banner-image {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: cover;
}

#image-card,
#login-card {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
